<template>
  <div
    @keyup.enter="playOrPause()"
    @keyup.space="playOrPause()"
    @keyup.up="addMinute()"
    @keyup.down="remMinute()"
    tabindex="-1"
    id="mainframe"
    :style="{
      backgroundImage: 'url(' + image + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }"
  >
    <div class="circles-container">
      <div v-if="timer" class="pulse-ring"></div>
      <div class="circle-layout">
        <vue-circle
          style="z-index: 100; size:500px"
          ref="circProg"
          :progress="0"
          :size="500"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="ghostwhite"
          :animation-start-value="0.5"
          :start-angle="-1.5"
          insert-mode="append"
          :thickness="4"
          :show-percent="false"
        >
          <div class="timer-buttons-layout">
            <button
              @click="addMinute"
              type="button"
              v-if="reseted"
              class="btn btn-primary btn-pad btn-lg"
            >
              <i class="fa fa-plus"></i>
            </button>
            <h1 v-on:wheel.down="addMinute" class="display-1 txt-align">
              {{ minutes }}:{{ seconds }}
            </h1>
            <button
              @click="remMinute"
              type="button"
              v-if="reseted"
              class="btn btn-primary btn-pad btn-lg"
            >
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </vue-circle>
      </div>
    </div>

    <div class="options">
      <button @click="startTimer" class="btn btn-primary" v-if="!timer">
        Start Focus
      </button>
      <button @click="pauseFocus" class="btn btn-danger" v-if="timer">
        Pause Focus
      </button>
      <button @click="newFocus" class="btn btn-outline-light btn-new-focus">
        New Focus
      </button>
    </div>

    <div class="fixed-to-bottom alert alert-danger alrt-show" ref="alrt">
      Control your desires!
    </div>

    <div class="fixed-bottom-right">
      <p class="light-text">
        Photo by {{ author }} on <a :href="unsplashRedirect">Unsplash</a>
      </p>
    </div>
  </div>
</template>

<script>
import VueCircle from "vue2-circle-progress/src/index.vue";
import "bootstrap/dist/css/bootstrap.min.css";
import PhotoGenerator from "./PhotoGenerator";

export default {
  name: "app",
  components: {
    VueCircle
  },
  data() {
    return {
      circSize: 100,
      fill: { gradient: ["#007bff"] },
      timer: null,
      startTimeVal: 25 * 60,
      totalTime: 25 * 60,
      reseted: true,
      image: "",
      unsplashRedirect: "",
      author: "",
      audio: new Audio(require("./assets/sounds/belltone.mp3")),
      isAudioEnabled: true
    };
  },
  methods: {
    startTimer: function() {
      this.timer = setInterval(() => this.countdown(), 1000);
      this.reseted = false;
    },
    padTime: function(time) {
      return (time < 10 ? "0" : "") + time;
    },
    countdown: function() {
      if (this.totalTime >= 1) {
        this.totalTime--;
        this.$refs.circProg.updateProgress(
          parseFloat((1 - this.totalTime / this.startTimeVal) * 100)
        );
      } else {
        this.totalTime = 0;
        this.newFocus();
        this.audio.play();
      }
    },
    pauseFocus: function() {
      clearInterval(this.timer);
      this.timer = null;
      this.$refs.alrt.classList.toggle("alrt-show", false);
    },
    newFocus: function() {
      clearInterval(this.timer);
      this.timer = null;
      this.$refs.circProg.updateProgress(0);
      this.totalTime = this.startTimeVal;
      this.reseted = true;
      this.$refs.alrt.classList.toggle("alrt-show", true);
    },
    addMinute: function() {
      this.totalTime = this.totalTime + 60;
      this.startTimeVal = this.totalTime;
    },
    remMinute: function() {
      if (this.totalTime > 0) this.totalTime = this.totalTime - 60;

      this.startTimeVal = this.totalTime;
    },
    getWallpaper() {
      let pg = new PhotoGenerator();
      pg.getRandomPhoto().then(data => {
        this.image = data.data[0].urls.regular + "&w=2560&dpi=2";
        this.author = data.data[0].user.name;
        this.unsplashRedirect = data.data[0].links.html;
      });
    },
    playOrPause() {
      this.timer != null ? this.pauseFocus() : this.startTimer();
    }
  },
  computed: {
    minutes: function() {
      const minutes = Math.floor(this.totalTime / 60);
      return this.padTime(minutes);
    },
    seconds: function() {
      const seconds = this.totalTime - this.minutes * 60;
      return this.padTime(seconds);
    }
  },
  mounted() {
    this.getWallpaper();
  }
};
</script>

<style>
* {
  box-sizing: border-box;
}

#mainframe {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ebebeb;
  -webkit-transition: background-image 0.2s ease-in-out;
  transition: background-image 0.2s ease-in-out;
}

.circles-container {
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}

.timer-buttons-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.circle-layout {
  text-align: center;
  z-index: 100;
}

.txt-align {
  display: inline;
  text-align: center;
  color: white;
  font-size: 110px;
}

.options {
  margin: 80px 0;
}

.btn-pad {
  margin: 4px 30px 0 30px;
  border-radius: 50%;
}

.btn-new-focus {
  margin: 0 20px;
  border-width: 2px;
  color: white;
}

.txt-size-sty {
  max-width: 5em;
  width: fit-content;
  font-size: 80px;
  text-align: center;
  border: none;
  padding-left: 40px;
}

.pulse-ring {
  position: absolute;
  content: "";
  width: 500px;
  height: 500px;
  border: 3px solid #fbfbfb;
  border-radius: 50%;
  animation: pulsate infinite 2s;
  z-index: 3;
}

.alrt-show {
  display: none;
}

.fixed-to-bottom {
  position: fixed;
  bottom: 0;
  margin-bottom: 24px;
  justify-content: center;
}

.fixed-bottom-right {
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 16px;
}

.light-text {
  color: #ebebeb;
  font-size: 12px;
  font-weight: 400;
}

@-webkit-keyframes pulsate {
  0% {
    -webkit-transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.3, 1.3);
    opacity: 0;
  }
}

/* Media queries - Portrait Mobile */
@media only screen and (max-width: 600px) and (orientation: portrait) {
  .pulse-ring {
    width: 300px;
    height: 300px;
  }

  .txt-align {
    font-size: 70px;
  }
}
</style>
